module.exports = __webpack_public_path__ + "img/rivers-solomon.40676d43.png";